import React from 'react'
import { Box, Text } from '@node-space/ui-components'
import { SidePanelRow, SidePanelRowProps } from './SidePanelRow'

export interface SidePanelSummaryProps {
  heading: string
  rows: SidePanelRowProps[]
}

export const SidePanelSummary = ({ heading, rows }: SidePanelSummaryProps) => {
  return (
    <>
      <Text variant="heading-4">{heading}</Text>
      <Box>
        {rows.map(detail => (
          <SidePanelRow key={detail?.label} {...detail} />
        ))}
      </Box>
    </>
  )
}
